import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          <div className="space-y-6">
            <h3 className="text-2xl font-bold">Contact Us</h3>
            
            <div className="space-y-4 text-sm">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-xl mt-0.5"></i>
                <p>Kyle Texas</p>
              </div>
              
              <div className="flex items-start space-x-3">
                <i className="ri-mail-line text-xl mt-0.5"></i>
                <a href="mailto:globaltechglass@gmail.com" className="hover:text-teal-400 transition-colors">
                  globaltechglass@gmail.com
                </a>
              </div>
              
              <div className="flex items-start space-x-3">
                <i className="ri-phone-line text-xl mt-0.5"></i>
                <div className="space-y-1">
                  <p>(512)876-9487 - Spencer</p>
                  <p>(737)240-2237 - Matt</p>
                </div>
              </div>
            </div>
            
            <p className="text-xs text-gray-400 pt-4">
              © 2023 by Global Tech Glass. All Rights Reserved.
            </p>
          </div>
          
          <div className="space-y-6">
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/wix"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <img
                  src="https://static.wixstatic.com/media/23fd2a2be53141ed810f4d3dcdcd01fa.png/v1/fill/w_20,h_20,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/23fd2a2be53141ed810f4d3dcdcd01fa.png"
                  alt="Facebook"
                  className="w-5 h-5"
                />
              </a>
              <a
                href="https://www.instagram.com/wix"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <img
                  src="https://static.wixstatic.com/media/81af6121f84c41a5b4391d7d37fce12a.png/v1/fill/w_20,h_20,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/81af6121f84c41a5b4391d7d37fce12a.png"
                  alt="Instagram"
                  className="w-5 h-5"
                />
              </a>
              <a
                href="https://www.yelp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                aria-label="Yelp"
              >
                <img
                  src="https://static.wixstatic.com/media/3ae0375b94ba46fca1f4e6c0f7992fc9.png/v1/fill/w_20,h_20,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/3ae0375b94ba46fca1f4e6c0f7992fc9.png"
                  alt="Yelp"
                  className="w-5 h-5"
                />
              </a>
            </div>
          </div>
          
          <div className="space-y-6">
            <nav className="space-y-3 text-sm">
              <Link to="/" className="block hover:text-teal-400 transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/services" className="block hover:text-teal-400 transition-colors cursor-pointer">
                Services
              </Link>
              <Link to="/projects" className="block hover:text-teal-400 transition-colors cursor-pointer">
                Gallery
              </Link>
              <Link to="/#contact" className="block hover:text-teal-400 transition-colors cursor-pointer">
                Contact
              </Link>
            </nav>
            
            <a
              href="tel:737-240-2237"
              className="inline-block bg-teal-600 text-white px-6 py-2 rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer text-sm font-semibold"
            >
              SCHEDULE NOW
            </a>
            
            <div className="pt-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
